import React, { type ReactNode, type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type LabelProps = {
	htmlFor: string;
	testId?: string;
	children: ReactNode;
};

const Label = ({ htmlFor, children, testId, ...props }: LabelProps) => (
	<StyledLabel
		htmlFor={htmlFor} // because linter...
		data-testid={testId}
		{...props}
	>
		{children}
	</StyledLabel>
);

type RadioProps = {
	children: ReactNode;
	name: string;
	checked: boolean;
	value: string;
	testId: string;
	onChange: (event: SyntheticEvent<HTMLInputElement>) => void;
};

let controlId = 0;

export const Radio = ({ children, testId, ...props }: RadioProps): React.JSX.Element => {
	// eslint-disable-next-line react-hooks/react-compiler
	controlId += 1;
	const id = `jql-builder-basic-datetime-dialog-radio-${controlId}`;
	return (
		<Label htmlFor={id} testId={testId}>
			<StyledInput type="radio" id={id} {...props} />
			<span>{children}</span>
		</Label>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledLabel = styled.label({
	alignItems: 'center',
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> span': {
		marginLeft: token('space.050'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledInput = styled.input({
	marginTop: token('space.0'),
	marginRight: token('space.050'),
	marginBottom: token('space.0'),
	marginLeft: token('space.050'),
});
